import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="roleta-creation"
export default class extends Controller {
  connect() {
    // Listen for the custom hide-message event
    document.addEventListener('hide-message', this.hideMessageAfterDelay.bind(this))
  }

  disconnect() {
    // Clean up event listener
    document.removeEventListener('hide-message', this.hideMessageAfterDelay.bind(this))
  }

  hideMessageAfterDelay(event) {
    const { selector, delay } = event.detail

    setTimeout(() => {
      const messageElement = document.querySelector(selector)
      if (messageElement) {
        // Add fade out animation
        messageElement.style.transition = 'opacity 0.3s ease-out'
        messageElement.style.opacity = '0'

        // Hide element after animation
        setTimeout(() => {
          messageElement.classList.add('hidden')
          messageElement.style.opacity = '1' // Reset for next time
        }, 300)
      }
    }, delay || 3000)
  }
}
